const defaultRender = (value) => (value ? value : '--');

const columns = [
    {
        title: 'File Name',
        dataIndex: 'files',
        render: (_, record) => record?.files?.service_name_slug ? <p className="capitalize">{record?.files?.service_name_slug}</p> : '--'
    },
    {
        title: 'File Number',
        dataIndex: 'files',
        render: (_, record) => record?.files?.file_number ? record?.files?.file_number : '--'
    },
    {
        title: 'Status',
        dataIndex: 'status',
        render: defaultRender,
    },
    {
        title: 'Amount',
        dataIndex: 'total_amount',
        render: defaultRender,
    },
    {
        title: 'Action',
        dataIndex: 'action',
        render: defaultRender,
    },
];

export default columns;